import {
  DateGroupSeparator,
  GrowGroupSeparator,
  MessageListBucketMeta,
} from '../../schema/message';

export const createQuerySeparator = (
  bucket: Extract<MessageListBucketMeta, { type: 'query' }>,
  boundary: 'start' | 'end'
): GrowGroupSeparator => ({
  type: 'query',
  boundary,
  groupId: bucket.groupId,
  lowerBound: bucket.lowerBound,
  upperBound: bucket.upperBound,
  queryType: bucket.queryType,
  backgroundColor: bucket.backgroundColor,
  title: bucket.title,
});

export const createDateSeparator = (dayKey: string): DateGroupSeparator => ({
  type: 'date',
  dayKey,
});
